<template>
  <div :class="$style.box">
    <!-- 底部背景 -->
    <div 
      @click="btnFunc(page.button_list[0])"
      :class="[$style.background, page.button_list[0].function == 2 ? 'copy-btn' : '']"
      :style="{backgroundImage: `url(${page.background})`}"
      :data-clipboard-text="page.button_list[0].function_value"
      >
      <!-- 关闭按钮 -->
      <div :class="$style.close" @click.stop="closePage">
        <img :src="page.close_background" />
      </div> 
    </div>
    <!-- 复制输入框 -->
    <input
      v-if="inputShow"
      type="text"
      :class="$style.copyInput"
      id="copy"
      readonly
      :value="inputVal"
    />
    <BoxDownload v-if="boxDownLoadShow" @close="boxDownLoadShow=false" :type="boxType"></BoxDownload>
  </div>
</template>

<script>
import Clipboard from 'clipboard';
import { mapActions } from 'vuex';
import { gameOpenDownloads, registSaveImgFunction, boxSkipAnyPage2Sdk, skipWXBox2Sdk } from '@/bridge/AppJsBridge';
import { getStorage } from '@/libs/utils';
import { generActLink } from '@/libs/business/box';
import { boxDownloadUrl, wxBoxDownloadUrl } from '@/config'
import BoxDownload from '../Suspend/common/boxDownload.vue';
import { flashCloseTrack } from '@/api/user'
import { buryReportV2 } from '@/libs/business/account';

export default {
  props: {
    page: {
      type: Object,
      default: null
    },
    inputShow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      inputVal: '',
      boxDownLoadShow: false,
      boxType: 'bt'
    };
  },
  computed: {
    portraitStyle() {
      return {
        width: '100%',
        height: '100%',
        background: `url(${this.page.background}) no-repeat`,
        backgroundSize: '100% 100%'
      }
    },
    landscapeStyle() {
      return {
        width: '100%',
        height: '100%',
        background: `url(${this.page.background}) no-repeat`,
        backgroundSize: '92% 100%'
      }
    }
  },
  components: {
    BoxDownload
  },
  mounted() {
    setTimeout(() => {
      this.copyInit();
    }, 500);
  },
  methods: {
    ...mapActions({
      report: 'activity/report',
      openCustomer: 'global/openCustomer'
    }),
    copyInit() {
      this.copy = new Clipboard('.copy-btn');
      this.copy.on('success', (e) => {
        this.$toast('复制成功');
        this.copy.destroy(); // 销毁，否则其他按钮会受影响
      });
    },
    async btnFunc(item) {
      buryReportV2('SDK_FLASH_BUTTON', {
        flash_id: this.page.flash_id,
        flash_name: this.page.flash_name
      })
      // 1跳转链接 2点击复制 3保存图片 4跳转SDK功能页:function_value 1 绑定手机 2 联系客服 3 实名认证
      let url = item.function_value
      switch (item.function) {
        case 1:
          this.$emit('showGift');
          // 如果是跳转盒子协议的地址，需要拼接上用户信息和参数
          if (item.function_value.indexOf('wxbt://com.hzwx.bt.box') !== -1) {
            url = await generActLink(url);
            this.boxType = 'bt';
            this.boxDownLoadShow = true
          } else if (item.function_value.indexOf('wxsy://com.hzwx.wx.box') !== -1) {
            url = await generActLink(url);
            this.boxType = 'wx';
            this.boxDownLoadShow = true
          }
          gameOpenDownloads({
            gameUrl: url
          });
          break;
        case 2:
          this.inputVal = item.function_value;
          this.copyInit();
          break;
        case 3:
          registSaveImgFunction(this.page.background);
          break;
        case 4:
          if (item.function_value == 1) {
            this.$emit('showBind');
          } else if (item.function_value == 2) {
            this.openCustomer();
          } else if (item.function_value == 3) {
            this.$emit('showRealName');
          } else if (item.function_value == 4) {
            this.$emit('redirectFloatPage', 'welfare')
            // 存储闪页信息用于跳转到对应页面上报使用
            this.$setStorage('buryport', {
              upload_type: '闪页跳转上报',
              flash_id: this.page.flash_id,
              flash_name: this.page.flash_name
            })
          } else if (item.function_value == 5) {
            this.$emit('redirectFloatPage', 'hangup')
            // 存储闪页信息用于跳转到对应页面上报使用
            this.$setStorage('buryport', {
              upload_type: '闪页跳转上报',
              flash_id: this.page.flash_id,
              flash_name: this.page.flash_name
            })
          }
          break;
        case 5:
          boxSkipAnyPage2Sdk({
            boxUrl: boxDownloadUrl(),
            routePath: item.function_value
          })
          break;
        case 6:
          skipWXBox2Sdk({
            event: 'boxAnyPage',
            syAppkey: "",
            boxUrl: wxBoxDownloadUrl(),
            routePath: item.function_value
          })
          break;
      }
    },
    closePage() {
      buryReportV2('SDK_FLASH_CLOSE', {
        flash_id: this.page.flash_id,
        flash_name: this.page.flash_name
      })
      this.$emit('closePage');
    }
  }
};
</script>

<style lang="scss" module>
.box {
  width: 100%;
  height: 100%;
  position: relative;
  .background {
    width: 431px;
    height: 229px;
    background-size: 100% 100%;
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    margin: auto;
    @media screen and (orientation: portrait) {
      width: 317px;
      height: 486px;
    }
  }
  .close {
    width: 40px;
    height: 40px;
    position: absolute;
    right: -16px;
    top: -16px;
    @media screen and (orientation: portrait) {
      right: 0px;
      top: 0px;
    }
    // background-color: pink;
    > img {
      width: 31px;
      position: absolute;
      right: 0px;
      top: 0px;
    }
  }
  .copyInput {
    position: absolute;
    left: -10000px;
  }
}
</style>